import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import '../../style.css';

function Kinder() {
  const details = [
    { icon: '📖', label: 'Libro', value: 'Look and See' },
    { icon: '🕮', label: 'Editorial', value: 'National Geographic' },
    { icon: '⌛', label: 'Horas por semana', value: '3 hrs.' },
    { icon: '📆', label: 'Duración del nivel', value: '15 semanas' },
  ];

  return (
    <div className="page-wrapper">
      <Helmet>
        <title>Inglés para Kinder | Culturlingua</title>
        <meta name="description" content="4 a 6 años · Aprendizaje a través de juegos y canciones" />
      </Helmet>

      <div className="page-hero">
        <div className="section-tag">Inglés · Culturlingua</div>
        <h1>Inglés para Kinder</h1>
        <p>4 a 6 años · Aprendizaje a través de juegos y canciones</p>
      </div>

      <section style={{background:'var(--cream)', padding:'80px 48px'}}>
        <div style={{maxWidth:'900px', margin:'0 auto'}}>

          <div style={{background:'white', borderRadius:'20px', padding:'40px', boxShadow:'0 2px 16px rgba(0,0,0,0.06)', marginBottom:'32px'}}>
            <div className="section-tag">Acerca del curso</div>
            <h2 className="section-headline" style={{fontSize:'1.6rem', marginBottom:'16px'}}>Inglés para Kinder</h2>
            <p style={{color:'var(--muted)', lineHeight:'1.8'}}>Nuestro curso sigue la PEP mexicana (Programa de Educación Preescolar), destacando el uso natural del inglés de forma dinámica y divertida mediante juegos, canciones, manualidades y dinámicas, promoviendo las habilidades de los niños en otras áreas del currículo, con énfasis en el desarrollo físico, trabajo en equipo y fonética.</p>
          </div>

          <div style={{display:'grid', gridTemplateColumns:'repeat(2,1fr)', gap:'16px', marginBottom:'40px'}}>
            {details.filter(d => d.value !== 'N/A').map((d) => (
              <div key={d.label} style={{background:'white', borderRadius:'14px', padding:'24px', boxShadow:'0 2px 8px rgba(0,0,0,0.05)', display:'flex', alignItems:'flex-start', gap:'14px'}}>
                <div style={{fontSize:'1.6rem'}}>{d.icon}</div>
                <div>
                  <div style={{fontSize:'0.75rem', color:'var(--muted)', textTransform:'uppercase', letterSpacing:'0.5px', fontWeight:'600', marginBottom:'4px'}}>{d.label}</div>
                  <div style={{fontWeight:'600', color:'var(--navy)'}}>{d.value}</div>
                </div>
              </div>
            ))}
          </div>

          <div style={{background:'var(--navy)', borderRadius:'20px', padding:'40px', textAlign:'center'}}>
            <h3 style={{fontFamily:'Fraunces, serif', fontSize:'1.6rem', color:'white', fontWeight:'900', marginBottom:'12px'}}>
              ¿Listo para empezar?
            </h3>
            <p style={{color:'rgba(255,255,255,0.6)', marginBottom:'28px'}}>Sin compromisos. Te contactamos para orientarte.</p>
            <div style={{display:'flex', gap:'16px', justifyContent:'center', flexWrap:'wrap'}}>
              <Link to="/contacto" className="btn-glow">Inscribirme →</Link>
              <Link to="/Examen-de-ubicacion" className="btn-outline">Examen de Ubicación</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Kinder;
